import type { ApiCallRecord } from "../types";

export class FlowStepError extends Error {
  expected?: string;
  actual?: string;
  apiCall?: ApiCallRecord;

  constructor(
    message: string,
    opts: { expected?: string; actual?: string; apiCall?: ApiCallRecord } = {}
  ) {
    super(message);
    this.name = "FlowStepError";
    this.expected = opts.expected;
    this.actual = opts.actual;
    this.apiCall = opts.apiCall;
  }
}

export class ApiCallError extends FlowStepError {
  constructor(message: string, apiCall: ApiCallRecord) {
    super(message, { apiCall });
    this.name = "ApiCallError";
  }
}

export class PollTimeoutError extends FlowStepError {
  attempts: number;
  constructor(message: string, attempts: number, expected: string, actual: string) {
    super(message, { expected, actual });
    this.name = "PollTimeoutError";
    this.attempts = attempts;
  }
}

export class FlowAbortedError extends Error {
  constructor() {
    super("Flow execution was cancelled");
    this.name = "FlowAbortedError";
  }
}

export class StepSkippedError extends Error {
  constructor(reason: string) {
    super(reason);
    this.name = "StepSkippedError";
  }
}

export const extractApiErrorMessage = (err: any): string => {
  const data = err?.response?.data;
  if (data) {
    if (typeof data === "string") return data;
    const candidate =
      data.errorMsg || data.message || data.error || data.msg || data.detail;
    if (Array.isArray(candidate)) return candidate.join("; ");
    if (candidate) return String(candidate);
  }
  return err?.message || "Unknown error";
};
